module.exports = __webpack_public_path__ + "img/zhang_1.61db4047.png";